import { memo } from "react";
import { Button } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";

import styles from "./ResetCustomizationButton.module.scss";
import { useDashboardCustomizationContext } from "../DashboardCustomizationContext";

const ResetCustomizationButton = () => {
  const { l10n } = useLocalization();
  const { resetOrder } = useDashboardCustomizationContext();

  return (
    <div className={styles["reset-container"]}>
      <Button
        kind="tertiary"
        startIcon="rotate-cw"
        onClick={resetOrder}
        label={l10n.getString("dashboard-customization-reset", null)}
      />
    </div>
  );
};

export default memo(ResetCustomizationButton);
